import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function KpiCard({
  label,
  value,
  sub,
  delta,
  invertDelta,
  showCompare,
}: {
  label: string;
  value: string;
  sub?: string;
  /** percentage change (e.g. 12.5 for +12.5%). null if undefined. */
  delta: number | null;
  /** when true, a negative delta is "good" (e.g. cost going down). */
  invertDelta?: boolean;
  showCompare: boolean;
}) {
  const hasDelta = showCompare && delta !== null && Number.isFinite(delta);
  const positive = (delta ?? 0) >= 0;
  const good = invertDelta ? !positive : positive;

  return (
    <Card>
      <CardContent className="p-4">
        <div className="text-xs text-muted-foreground">{label}</div>
        <div className="mt-1 text-xl font-semibold tabular-nums">{value}</div>
        <div className="mt-1 flex items-center justify-between gap-2 text-[11px]">
          {sub ? <span className="text-muted-foreground">{sub}</span> : <span />}
          {hasDelta ? (
            <span
              className={cn(
                "inline-flex items-center gap-0.5 font-medium tabular-nums",
                Math.abs(delta!) < 0.5
                  ? "text-muted-foreground"
                  : good
                  ? "text-emerald-600"
                  : "text-destructive",
              )}
            >
              {Math.abs(delta!) < 0.5 ? (
                <Minus className="h-3 w-3" />
              ) : positive ? (
                <ArrowUpRight className="h-3 w-3" />
              ) : (
                <ArrowDownRight className="h-3 w-3" />
              )}
              {Math.abs(delta!).toFixed(1)}%
            </span>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );
}
